import { createApiSlice } from "@common";
import {
  CRUD_CONVERT_PROSPECT_TO_INQUIRY,
  CRUD_CONVERT_PROSPECT_TO_LEAD,
} from "@routes";

const apiConfig = [
  {
    name: "convertProspectToLead",
    method: "post",
    url: CRUD_CONVERT_PROSPECT_TO_LEAD,
    stateKey: "message",
  },
  {
    name: "convertProspectToInquiry",
    method: "post",
    url: CRUD_CONVERT_PROSPECT_TO_INQUIRY,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    loading: false,
    message: "",
  },
  reducers: {},
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "prospectConversion",
  apiConfig,
  customReducers
);

const prospectConversionSlice = slice;

export default prospectConversionSlice.reducer;

export const {
  convertProspectToLead,
  convertProspectToInquiry
} = thunks;

